/* GAME MANAGER - Handles Communication with child frame containing game */

import {isValidEvent} from './utils/initializeSdk'
import {MessageData} from './utils/types'
import {discordSdk, instanceId} from './utils/initializeSdk'
import { JoinLeftRoomEvent, ShareLinkEvent } from '@shared/events';
import { beginCountdown, checkProxy, disableInviteButtonMessage, enableInviteButton, globalGameVersion, myParticipantId, myParticipantName, sendMessageToServer, openGameModeSelection } from './activityclient';
import {DiscordSDK, Permissions, PermissionUtils} from '@discord/embedded-app-sdk';
import { JoinLeftRoomMessage } from '@shared/messages';
import { finishLogin } from './index';

let childIFrame:HTMLIFrameElement;
export let invite_opened:boolean = false;
let gameFrameLoaded:boolean = false;
let notification_container:HTMLElement;

// Function to update the value (optional, for encapsulation)
export function setInviteOpened(value: boolean) {
    invite_opened = value;
}

// GAME MANAGER - EXPORTS 
export async function setupParentIframe() {
    try {
        console.log("discord sdk pre initialized");
        notifyChildParentIsReady(); //FIXME - This doesnt do anything yet
        console.log("discord sdk initialized");      
        window.addEventListener('message', (event) => handleMessage( event));
    } catch (error: any) {
        console.error('Error setting up parent iframe:', error);
    }
}

export async function openInviteDialog(){
    try {
        //const {permissions} = await discordSdk.commands.getChannelPermissions();
        //if (PermissionUtils.can(Permissions.CREATE_INSTANT_INVITE, permissions)) {
        if(await invitePermissionEnabled()){
            await discordSdk.commands.openInviteDialog();
            // successfully opened dialog
            if(!invite_opened){
                sendMessageToChild({"type":"invite-status", "show":"1" });
            }
            
        } else {
            console.warn('User does not have CREATE_INSTANT_INVITE permissions');
            if(!invite_opened){
                sendMessageToChild({"type":"invite-status", "show":"0" });
            }
        }
    } catch (err: any) {
        // failed to fetch permissions or open dialog
        console.warn(err.message);
        if(!invite_opened){
            sendMessageToChild({"type":"invite-status", "show":"0" });
        }
    }

    if(!invite_opened){
        disableInviteButtonMessage();
        invite_opened = true;
    }
}

export async function invitePermissionEnabled(){
    const {permissions} = await discordSdk.commands.getChannelPermissions();
    return PermissionUtils.can(Permissions.CREATE_INSTANT_INVITE, permissions);
}

export function sendMessageToChild(message: any) {
    const childFrame = getChildIframe();
    if (childFrame && childFrame.contentWindow) {
        console.log("sendMessageToChild: " + JSON.stringify(message));

        childFrame.contentWindow.postMessage(message, '*');
    } else {
        console.error('Child iframe not available');
    }
};


export function triggerJoinGame(shareLink: string, isLeader: boolean) {
    childIFrame = <HTMLIFrameElement>document.getElementById("child-iframe");
    childIFrame.referrerPolicy = "unsafe-url";
    const waitingForRoomElem:HTMLImageElement = <HTMLImageElement>document.getElementById("waiting_for_room");

    const isProxy:boolean = checkProxy();

    const CLIENT_ID = process.env.CLIENT_ID??"1258530387605327983";
    //const baseIframeUrl = childIFrame.dataset.baseSrc;
    const baseIframeUrl = (isProxy ? '/.proxy' : 'https://warmerise.com') + '/Warmerise/' + getQueryParam('build_channel', CLIENT_ID === '1258530387605327983' ? 'ProductionWebGL' : 'StagingWebGL', ['StagingWebGL', 'ProductionWebGL']) + '/PlayerData/';

    if(baseIframeUrl === undefined) return;

    childIFrame.style.display = "block";
    waitingForRoomElem.style.display = "none";

    if(shareLink === ""){
        childIFrame.src = baseIframeUrl + '?v=' + globalGameVersion;

        /*if(childIFrame){
            childIFrame.addEventListener('load', () => {
                if(childIFrame.contentWindow){
                    childIFrame.contentWindow.addEventListener('hashchange', () => {
                        if(childIFrame.contentWindow && childIFrame.contentWindow.location.hash === "#loaded"){
                            enableInviteButton();
                        }
                    });
                }
            });
        }*/

        return;
    }

    /*childIFrame.style.display = "none";
    waitingForRoomElem.style.display = "block";
    //waitingForRoomElem.innerHTML = "Waiting for Room.";
    waitingForRoomElem.src = "/.proxy/war/TemplateData/waiting_for_room.png";*/

    //if(shareLink === "") return;

    let paramIndex = -1;
    if(shareLink === "isLeader"){
        paramIndex = 0;
        if(isGameFrameLoaded()){
            applyInviteLink("?join=isLeader", baseIframeUrl);
        }else{
            childIFrame.src = baseIframeUrl + '?v=' + globalGameVersion;
        }
    }else{
        paramIndex = shareLink.indexOf("?n=");
        if(paramIndex > -1){
            paramIndex += 3;
        }else{
            paramIndex = shareLink.indexOf("?join=");
            if(paramIndex > -1){
                paramIndex += 6;
            }
        }
    }
    
    if(paramIndex < 0) return;

    var linkParams = "?join="+shareLink.substring(paramIndex);

    beginCountdown(linkParams, baseIframeUrl, isLeader);
    
    /*if(childIFrame!=null /*&& childIFrame.src != baseIframeUrl+linkParams* /) {
        if(childIFrame.src === undefined || childIFrame.src === null || childIFrame.contentWindow === null || childIFrame.contentWindow.location.hash !== "#loaded"){
            childIFrame.src = baseIframeUrl+linkParams;
        }else{
            sendMessageToChild({"type":"joinroom-command", "link":linkParams });
        }
 
        childIFrame.style.display = "block";
        waitingForRoomElem.style.display = "none";
    }*/
}

export function getQueryParam(param:string, defaultValue:string = '', allowedValues:any = []) {
    const urlParams = new URLSearchParams(window.location.search);
    const value = urlParams.get(param);

    // Check if the value is valid (not null, not empty, and in the allowedValues list if provided)
    if (value !== null && value.trim() !== '' && (allowedValues.length === 0 || allowedValues.includes(value))) {
        return value;
    }
    
    return defaultValue;
}


export function isGameFrameLoaded() {
    /*return childIFrame && typeof childIFrame.src !== 'undefined' && childIFrame.src !== null && childIFrame.contentWindow !== null && childIFrame.contentWindow.location.hash === "#loaded";*/
    return gameFrameLoaded;
}

export function applyInviteLink(shareLink: string, baseIframeUrl: string) {
    if(childIFrame!=null) {
        if(/*childIFrame.src === undefined || childIFrame.src === null || childIFrame.contentWindow === null || childIFrame.contentWindow.location.hash !== "#loaded"*/ !isGameFrameLoaded()){
            if(shareLink.indexOf("%%apply%%") > -1){
                childIFrame.src = baseIframeUrl;
            }else{
                childIFrame.src = baseIframeUrl+shareLink;
            }
        }else{
            sendMessageToChild({"type":"joinroom-command", "link":shareLink });
        }
    }
}

/*export function triggerJoinGame(shareLink: string) {
    console.log("triggerJoinGame: " + shareLink);

    sendMessageToChild({"type":"joinroom-command", "link":shareLink })
}*/
  

// GAME MANAGER - Message Handling Implementation (Window.PostMessage from client game iframe)

async function handleMessage( messageEvent: any) { //MessageEvent<MessageData>
    // Bail out if messageData is not an "{}" object
    if (typeof messageEvent.data !== 'object' || Array.isArray(messageEvent.data) || messageEvent.data === null) {
        return;
    }
    
    var { nonce, event, command, data, args } = messageEvent.data;

    if(event) {
        switch(event) {
            case 'ShareLinkFromBrowser':
                handleShareLinkEvent(messageEvent.data as ShareLinkEvent);
                break;
            case 'OpenExternalLink':
                handleOpenExternalLink(messageEvent.data as ShareLinkEvent);
                break;
            case 'OpenInviteDialog':
                handleOpenInviteDialog();
                break;
            case 'JoinLeftRoom':
                let data1:any = messageEvent.data.data as any;
                data1.type = 'join-left-room';
                data1.userid = myParticipantId;
                data1.username = myParticipantName;
                handleJoinLeftRoomEvent(data1 as JoinLeftRoomMessage);
                break;
            case 'GameLoaded':
                gameFrameLoaded = true;
                enableInviteButton();
                //Send event to apply the leader
                if(window.isLeader){
                    triggerJoinGame("isLeader", true);
                }
                break;
            case 'FullScreen':
                if(checkProxy() || window.top === window.self){
                    if(document.fullscreenElement !== null){
                        document.exitFullscreen();
                    }else{
                        document.body.requestFullscreen({navigationUI: "hide"});
                    }
                }
                break;
            case 'SSOClose':
                if(finishLogin){
                    finishLogin(JSON.stringify(messageEvent.data.data));
                }
                break;
            case 'GameModeSelect':
                openGameModeSelection(messageEvent.data.data.source);
                break;
        }
    } else if (command) {
        switch(command) {
        }        
    }
    
}

function handleJoinLeftRoomEvent(event:JoinLeftRoomMessage){
    if(!checkProxy()){
        if(!notification_container){
            notification_container = document.getElementById("notification_container") as HTMLElement;
        }
        if(event.left === "1"){
            notification_container.removeAttribute("style");
        }else{
            notification_container.style.display = "none";
        }
    }
    
    sendMessageToServer(event);
}

function handleShareLinkEvent(event:ShareLinkEvent) {    
    sendMessageToServer({'type':'share-link', shareLink:event.data.shareLink});
    disableInviteButtonMessage();
}

function handleOpenExternalLink(event:ShareLinkEvent){
    // Once the sdk has established the connection with the discord client, external
    // links can be launched
    discordSdk.commands.openExternalLink({
        url: event.data.shareLink,
    });
}

function handleOpenInviteDialog(){
    openInviteDialog();/*.then(() => {
        console.log('Invite dialog opened successfully.');
    })
    .catch((error) => {
        console.error('Failed to open invite dialog:', error);
    });*/
}


//This was from the nested-messages example and these messages arent used?
/*
function oldHandleMessage() {
    switch (command) {
        case 'NOTIFY_CHILD_IFRAME_IS_READY': {
            notifyChildParentIsReady(); //FIXME - this doesnt do anything yet
            break;
        }
        case 'SUBSCRIBE': {
            if (event == null) {
                throw new Error('SUBSCRIBE event is undefined');
            }

            if (isValidEvent(event)) {
                if (args !== undefined) {
                    discordSdk.subscribe(event, handleSubscribeEvent, args as any);
                } else {
                    discordSdk.subscribe(event, handleSubscribeEvent);
                }
            } else {
                console.error(`Invalid event type: ${event}`);
            }
            break;
        }
        case 'UNSUBSCRIBE': {
            if (event == null) {
                throw new Error('UNSUBSCRIBE event is undefined');
            }

            if (isValidEvent(event)) {
                discordSdk.unsubscribe(event, handleSubscribeEvent);
            } else {
                console.error(`Invalid event type: ${event}`);
            }
            break;
        }
        case 'SET_ACTIVITY': {
            const reply = await discordSdk.commands.setActivity(data as any);
            getChildIframe().contentWindow?.postMessage({ nonce, event, command, data: reply }, '*');
            break;
        }
    }    
}
*/


function handleSubscribeEvent(eventData: any) {
    getChildIframe().contentWindow?.postMessage(
        {
            event,
            command: 'DISPATCH',
            data: eventData,
        },
        '*'
    );
}

function getChildIframe(): HTMLIFrameElement {
    const iframe = document.getElementById('child-iframe') as HTMLIFrameElement | null;
    if (iframe == null) {
        throw new Error('Child iframe not found');
    }
    return iframe;
}

function notifyChildParentIsReady() {
    const iframe = getChildIframe();   //FIXME - This doesnt do anything
}








/* These functions are not used yet */

function updateIframeSrcWithRandomNumber() {
    // Implement this function if needed
}

function sendActivityId() {
    const activityId = getActivityId();
    const iframe = getChildIframe();
    iframe.contentWindow!.postMessage({
        type: 'activityId',
        activityId: activityId,
    }, window.location.origin);
}

function getActivityId() {    
    return instanceId; //Fixed.
}